export function intersection<T, U>(
  a: readonly T[],
  b: readonly U[]
): Array<T & U> {
  return b.filter((value): value is T & U => a.includes(value as T & U));
}
